import ModalHeader from '@molecules/ModalHeader';
import ModalWindow from '@organisms/modals/ModalWindow';
import {FC} from 'react';
import {
  ButtonsWrapper,
  ModalContent,
  ModalWrapper,
  DeleteUserWrapper,
  DeleteUsersEmailsWrapper,
} from './DeleteUserModal.styles';
import Button from '@atoms/Button';
import Avatar from '@atoms/Avatar';
import Text from '@atoms/Text';
import {theme} from '@styles/theme';
import {IUser} from '@types';
import {useDispatch, useSelector} from 'react-redux';
import {deleteUsers, users} from '@store/slices/users';
import {AppDispatch} from '@store';

interface Props {
  isOpened: boolean;
  usersIds: number[];
  onCloseRequest: () => void;
}

const DeleteUserModal: FC<Props> = ({isOpened, onCloseRequest, usersIds}) => {
  const dispatch = useDispatch<AppDispatch>();
  const usersArr: IUser[] = useSelector(users);
  const firstUser = usersArr.find(user => {
    return user.id === usersIds[0];
  });

  const DeleteUser = () => {
    dispatch(deleteUsers(usersIds));
    onCloseRequest();
  };

  return (
    <ModalWindow isOpen={isOpened} overflowIsVisible>
      <ModalWrapper>
        <ModalHeader
          title={usersIds.length < 2 ? 'Удалить пользователя' : 'Удалить пользователей'}
          onClose={onCloseRequest}
        />
        <ModalContent>
          {usersIds.length < 2 && (
            <DeleteUserWrapper>
              <Avatar img={firstUser?.avatar_url} size={48} />
              <div>
                <Text text={firstUser?.username || ''} color={theme.colors.basic01} />
                <Text
                  text={firstUser?.email || ''}
                  type="tinyR"
                  color={theme.colors.basic02}
                />
              </div>
            </DeleteUserWrapper>
          )}
          <DeleteUsersEmailsWrapper>
            <Text
              text={`Вы уверены, что хотите удалить пользовател${usersIds.length < 2 ? 'я' : 'ей'} `}
              display="inline"
            />
            {!!usersIds.length &&
              usersIds.map((userId, idx) => {
                return (
                  <Text
                    key={`delete-user-email-${userId}`}
                    text={`${idx > 0 ? ',' : ''}
                      ${
                        usersArr.find(user => {
                          return user.id === userId;
                        })?.email || ''
                      }`}
                    type="bodyM"
                    display="inline"
                  />
                );
              })}
            <Text text="?" display="inline" />
            <Text text="Это действие необратимо." />
          </DeleteUsersEmailsWrapper>
        </ModalContent>
        <ButtonsWrapper>
          <Button
            fullWidth
            title="Удалить"
            variant="filled"
            redButton
            onClick={DeleteUser}
          />
          <Button
            fullWidth
            title="Отменить"
            onClick={() => {
              onCloseRequest();
            }}
          />
        </ButtonsWrapper>
      </ModalWrapper>
    </ModalWindow>
  );
};

export default DeleteUserModal;
